<template>
    <div class="tools">
        <nav class="ito-tabs">
            <template v-for="tab in tabs">
                <router-link :to="tab.target" :class="{ active: tab.active }" @click.native="getSoundClick" v-if="tab.visible">{{ $t(tab.label) }}</router-link>
            </template>
        </nav>
    </div>
</template>
<script>
import { soundClick } from '../../../utils/utils';

export default {
    name: 'NavTabs',
    props: ['user_info'],
    data() {
        const current = this.$route.name
        return {
            tabs: [
                { label: 'report', target: { name: 'parent_report' }, active: current == 'parent_report', visible: true },
                { label: 'certificate', target: { name: 'parent_certificate' }, active: current == 'parent_certificate', visible: this.user_info.student_type == 1 },
                { label: 'feedback', target: { name: 'parent_feedback' }, active: current == 'parent_feedback', visible: this.user_info.student_type == 1 },
                { label: 'account_information', target: { name: 'parent_account' }, active: current == 'parent_account', visible: true },
                { label: 'daily_comment', target: { name: 'parent_daily_comment' }, active: current == 'parent_daily_comment', visible: true },
            ]
        }
    },

    methods: {
        getSoundClick() {
            soundClick();
        },
    }
}
</script>